import React, { useEffect, useRef, useState } from 'react'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import BasicInfo from './components/BasicInfo'
import MixrVenue from './components/MixrVenue'
import MixrTiming from './components/MixrTiming'
import MixrInterests from './components/MixrInterests'
import Button from 'srcReact/components/common2/Button'
import MixrPicture from './components/MixrPicture'
import { useSelector, useDispatch } from 'react-redux'
import { commonActions } from 'srcReact/components'
import { isPastDate, isPastDateWithTZ } from 'srcReact/helpers/datetimeHelper'
import Loader from 'srcReact/components/common2/Loader'
import Popup from 'reactjs-popup'
import Icon from 'srcReact/components/icons/Icon'
import { decode } from 'html-entities/lib/index'
import Link from 'react-router-dom/Link'
import { redirectToPage } from 'srcReact/helpers/history'
import colorVariables from 'srcReact/assets/scss/global/base/_variables.scss'
import { alertActions, AlertContainer } from 'srcReact/Alert'
import { mixrActions } from 'srcReact/Mixr/actions'
import SaveDraftModal from '../components/SaveDraftModal'
import { useBeforeunload } from 'react-beforeunload'
import { getCreateMixrParams } from '../helpers/getCreateMixrParams'
import CreateFromExisting from './components/CreateFromExisting'
import AdvanceSettings from './components/AdvanceSettings'
import Modal from 'srcReact/components/common2/Modal'
import ServerErrors from 'srcReact/components/popinsContent/ServerErrors'

export default function CreateMixr(props) {
  const { fromGroupId, fromGroup } = props
  const { t } = useTranslation()
  const [showMixrPicture, setShowMixrPicture] = useState(false)
  const [showMixrTiming, setShowMixrTiming] = useState(false)
  const [showMixrVenue, setShowMixrVenue] = useState(false)
  const [showMixrInterests, setShowMixrInterests] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [isPreviewUpdate, setIsPreviewUpdate] = useState(false)
  const [isSaveDraftModalOpen, setIsSaveDraftModalOpen] = useState(false)
  const [currentPath, setCurrentPath] = useState('')
  const [hasFormErrors, setHasFormErrors] = useState(false)
  const [formErrorMessage, setFormErrorMessage] = useState(false)
  const [showErrorPopup, setShowErrorPopup] = useState(false)
  const isDraftSaved = useRef(false)
  const unblockRef = useRef()

  const dispatch = useDispatch()
  const {
    alert,
    login: { user: loggedInUser },
    common: { groupsByOrgId, timezone, selectedInterests, isNative, isMobile },
    mixr: { mixr, saveDraft, createdMixrId, createdMixrName, createdMixrUrl, createUpdateErrors },
    mixr: {
      mixr: {
        name,
        description,
        is_preview,
        preview_in_modal,
        group: selectedGroup,
        attending_type,
        logged_user,
        createMixrType,
        isAdvanceSettingsVisible,
        group,
        local_start_at: startDatetime,
        local_end_at: endDatetime
      }
    }
  } = useSelector((state) => state)

  const mixrPictureRef = useRef(null)
  const mixrVenueRef = useRef(null)
  const mixrTimingRef = useRef(null)
  const mixrInterestsRef = useRef(null)
  const buttonsRef = useRef(null)
  const lastContainerRef = useRef(null)

  const showSection = (sectionName) => {
    switch (sectionName) {
      case 'mixrPicture': {
        setShowMixrPicture(true)
        break
      }
      case 'mixrTiming': {
        setShowMixrTiming(true)
        break
      }
      case 'mixrVenue': {
        setShowMixrVenue(true)
        break
      }
      case 'mixrInterests': {
        setShowMixrInterests(true)
        break
      }
    }
  }

  useEffect(() => {
    if (!saveDraft.loading && saveDraft.success) {
      isDraftSaved.current = true
      dispatch(mixrActions.resetSaveDraftData())
      leavePage()
    }
  }, [saveDraft.loading])

  useBeforeunload((event) => {
    if (!isNative && !saveDraft.success && currentPath !== '/0/create-mixr') {
      event.stopPropagation()
      event.preventDefault()
    }
  })

  useEffect(() => {
    if (isAdvanceSettingsVisible) {
      lastContainerRef.current.scrollIntoView(true, { behavior: 'smooth' })
    }
  }, [isAdvanceSettingsVisible])

  useEffect(() => {
    if (props && props.history) {
      //unblock react routing if target redirection page is not create-mixr/edit-preview and home/event
      unblockRef.current = props.history.block((prompt) => {
        if (isDraftSaved.current || prompt.pathname.includes('home/event')) {
          setIsSaveDraftModalOpen(false)
          return true
        } else {
          if (selectedGroup?.group_id > 0 && name?.length > 0 && description?.length > 0) {
            setCurrentPath(prompt.pathname)
            setIsSaveDraftModalOpen(true)
            return false
          }
        }
      })
    }
    return () => {
      unblockRef.current && unblockRef.current()
    }
  }, [props.history, selectedGroup, name, description])

  useEffect(() => {
    if (createUpdateErrors && createUpdateErrors.length > 0) {
      setShowLoader(false)
      setShowErrorPopup(true)
    } else {
      setShowErrorPopup(false)
    }
  }, [createUpdateErrors])
  const closeErrorPopup = () => {
    setShowErrorPopup(false)
  }
  useEffect(() => {
    if (createdMixrUrl?.length > 0) {
      redirectToPage(`/0/home/event/${createdMixrId}`, isNative)
    }
  }, [createdMixrId, createdMixrName, createdMixrUrl])
  useEffect(() => {
    if (!preview_in_modal) {
      setIsPreviewUpdate(is_preview)
    }
  }, [is_preview, preview_in_modal])

  useEffect(() => {
    if (isPastDate(startDatetime) || isPastDate(endDatetime)) {
      mixrTimingRef?.current?.scrollIntoView(true, { behavior: 'smooth' })
    }
  }, [isPreviewUpdate])

  useEffect(() => {
    if (selectedGroup) {
      if (selectedGroup.can_plan_mixr && selectedGroup.can_plan_mixr.toString() === '1') {
        dispatch(mixrActions.setMixrData([{ key: 'createMixrType', value: 'plan' }]))
      } else if (selectedGroup.can_suggest_mixr && selectedGroup.can_suggest_mixr.toString() === '1') {
        dispatch(mixrActions.setMixrData([{ key: 'createMixrType', value: 'suggest' }]))
      } else if (logged_user && logged_user.group_role === 'organizer') {
        dispatch(mixrActions.setMixrData([{ key: 'createMixrType', value: 'plan' }]))
      } else {
        dispatch(mixrActions.setMixrData([{ key: 'createMixrType', value: '' }]))
      }
    }
  }, [selectedGroup])

  useEffect(() => {
    if (showMixrPicture) {
      mixrPictureRef.current.scrollIntoView(true, { behavior: 'smooth' })
    }
  }, [showMixrPicture])
  useEffect(() => {
    if (showMixrTiming) {
      mixrTimingRef.current.scrollIntoView(true, { behavior: 'smooth' })
    }
  }, [showMixrTiming])
  useEffect(() => {
    if (showMixrVenue) {
      mixrVenueRef.current.scrollIntoView(true, { behavior: 'smooth' })
    }
  }, [showMixrVenue])
  useEffect(() => {
    if (showMixrInterests) {
      mixrInterestsRef.current.scrollIntoView(true, { behavior: 'smooth' })
    }
  }, [showMixrInterests])
  //commented because of 1206779294123080 => here is the new issue - I cannot save the draft - When I click on quitter & enregistrer
  // useEffect(() => {
  //   //if redirect url does not include "edit-preview", then clear mixr data.
  //   if (location && !location.pathname.includes('edit-preview')) {
  //     dispatch(mixrActions.setPreviewMixrData(null))
  //   }
  // }, [location && location.pathname])

  const getGroupInterests = () => {
    let interests = selectedGroup?.interests || []

    const groupWithInterests = groupsByOrgId?.list?.find((g) => g.group_id == selectedGroup?.id)
    if (groupWithInterests?.interests) {
      interests = groupWithInterests.interests
    }
    return interests
  }

  const closeLoaderModal = () => {
    setShowLoader(false)
  }

  const clearMixrData = () => {
    if (!isPreviewUpdate) {
      dispatch(commonActions.fileCreationRemove())
      dispatch(commonActions.updateSelectedInterests([]))
      dispatch(mixrActions.clearCreatedMixrValues())
    }
  }

  const handleShowPreview = () => {
    let hasErrors = false
    const errorElements = document.querySelectorAll('[role="alert"][class*="error"]')
    for (let i = 0; i < errorElements.length; i++) {
      if (errorElements[i].innerHTML) {
        hasErrors = true
        setHasFormErrors(true)
        setFormErrorMessage(t('global.formError'))
        break
      }
    }
    //prevent going to preview page if form has an error
    if (!hasErrors) {
      if (!isFormValid()) {
        setHasFormErrors(true)
      } else {
        setFormErrorMessage('')
        setHasFormErrors(false)
        dispatch(
          mixrActions.setMixrData([
            { key: 'is_preview', value: true },
            {
              key: 'logged_user',
              value: {
                mixr_attending: attending_type === 'virtual' ? 'virtual' : 'in_person',
                mixr_role: 'organizer',
                group_attending: 'joined',
                group_role:
                  selectedGroup && selectedGroup.group_role ? selectedGroup.group_role : logged_user.group_role
              }
            },
            {
              key: 'participants',
              value: {
                going: {
                  total: 1,
                  in_person: attending_type === 'in_person' || attending_type === 'both' ? 1 : 0,
                  virtual: attending_type === 'virtual' || attending_type === 'both' ? 1 : 0
                },
                invited: {
                  all: 1,
                  no_reply: 0,
                  not_going: 0,
                  going: 1
                },
                staff: 1
              }
            },
            { key: 'users', value: [{ ...loggedInUser, role: 'organizer' }] },
            { key: 'staff', value: [{ ...loggedInUser }] },
            {
              ...(!mixr.interests && selectedInterests?.length > 0
                ? { key: 'interests', value: selectedInterests }
                : {})
            }
          ])
        )
        redirectToPage(`/0/home/event/preview`, isNative)
      }
    }
  }

  const closeModal = () => {
    setIsSaveDraftModalOpen(false)
  }

  const handleLeave = () => {
    // localStorage.removeItem('mixr_preview_edit')
    leavePage()
  }

  const leavePage = () => {
    localStorage.removeItem('mixr_preview')
    setIsSaveDraftModalOpen(false)
    dispatch(mixrActions.resetSaveDraftData())
    props.history.block(() => {})
    if (currentPath) {
      //if user clicks on create mixr in header, then it should reload the page, to move all internal usestate of the page
      if (currentPath === '/0/create-mixr') {
        window.location = `${config.webUrl}${currentPath}`
      } else {
        props.history.push(currentPath)
      }
    }
  }

  const handleSaveDraft = () => {
    const mixrInfomation = getCreateMixrParams(mixr)
    dispatch(mixrActions.saveDraft(mixrInfomation))
  }

  const handleCreateMixr = () => {
    let hasErrors = false
    const errorElements = document.querySelectorAll('[role="alert"][class*="error"]')
    for (let i = 0; i < errorElements.length; i++) {
      if (errorElements[i].innerHTML) {
        hasErrors = true
        setHasFormErrors(true)
        setFormErrorMessage(t('global.formError'))
        break
      }
    }

    //prevent going to post mixrif form has an error
    if (!hasErrors) {
      if (!isFormValid()) {
        setHasFormErrors(true)
      } else {
        setShowLoader(true)
        const mixrInfomation = getCreateMixrParams(mixr, selectedInterests)
        dispatch(mixrActions.createMixr(mixrInfomation.group_id, mixrInfomation))
      }
    }
  }

  const isFormValid = () => {
    const { location, join_in_link, interests, fees } = mixr
    if (!location && !join_in_link) {
      setFormErrorMessage(t('event.create.clientErrors.mixrVenue'))
      return false
    }
    if (
      (!interests && selectedInterests?.length === 0) ||
      (interests?.length === 0 && selectedInterests?.length === 0)
    ) {
      setFormErrorMessage(t('interestPicker.info', { count: 1 }))
      return false
    }
    if (isPastDateWithTZ(mixr.local_start_at, mixr.location?.timezone)) {
      setFormErrorMessage(t('event.create.clientErrors.noPastDateMixr'))
      return false
    }
    if (fees && fees.length > 0) {
      const pricingDetails = JSON.parse(JSON.stringify([...fees]))
      let selectedCurrency = ''
      let selectedCategories = []
      for (let i = 0; i < pricingDetails.length; i++) {
        const { amount, currency_code, category_id, category_other } = pricingDetails[i]
        if (!selectedCurrency) {
          selectedCurrency = currency_code
        }

        if (!amount || amount <= 0) {
          setFormErrorMessage(t('event.create.timing.atleastOnePricingErrorMessage'))
          return false
        }

        if (currency_code === '' || currency_code === undefined) {
          setFormErrorMessage(t('event.create.timing.atleastOnePricingErrorMessage'))
          return false
        } else if (selectedCurrency && selectedCurrency.length > 0 && currency_code !== selectedCurrency) {
          setFormErrorMessage(t('event.create.timing.atleastOnePricingErrorMessage'))
          return false
        }

        if (category_id === '' || category_id === undefined) {
          setFormErrorMessage(t('event.create.timing.atleastOnePricingErrorMessage'))
          return false
        }

        if (category_id === -1) {
          setFormErrorMessage(t('event.create.timing.atleastOnePricingErrorMessage'))
          return false
        } else if (
          selectedCategories &&
          selectedCategories.length > 0 &&
          selectedCategories.includes(category_id.toString())
        ) {
          setFormErrorMessage(t('event.create.timing.atleastOnePricingErrorMessage'))
          return false
        }

        if (category_id === 8 && category_other && category_other.length === 0) {
          setFormErrorMessage(t('event.create.timing.atleastOnePricingErrorMessage'))
          return false
        }
      }
    }
    setFormErrorMessage('')
    return true
  }

  return (
    <PageContainer
      pageClassName={styles.pageContainer}
      pageTitle={createMixrType === 'plan' ? t('global.planMixr') : t('global.suggestMixr')}
      withFooter={false}>
      {alert && alert.message ? (
        <AlertContainer
          title={t('error.error_alert_title')}
          message={alert.message}
          show={!!alert.message}
          handleClose={() => dispatch(alertActions.clear())}
        />
      ) : null}
      {fromGroup && fromGroup.group_id > 0 && !isPreviewUpdate && (
        <div className={styles.headerContainer}>
          <Link className={styles.backUrl} to={`/0/home/group/${fromGroup.group_id}`}>
            <Icon styleModifier={styles.backIcon} name='arrow-left24' />
            <span>{decode(fromGroup.group_name)}</span>
          </Link>
        </div>
      )}

      <form className={`${styles.container} ${fromGroupId > 0 && styles.containerWithMarginTop}`}>
        <h1 className={styles.title}>{createMixrType === 'plan' ? t('global.planMixr') : t('global.suggestMixr')} </h1>
        <CreateFromExisting
          setHasFormErrors={setHasFormErrors}
          attachedGroupId={mixr?.group?.group_id || fromGroupId}
        />

        <div className={`${styles.outerContainer} ${styles.firstOuterContainer}  `}>
          <div className={`${styles.innerContainer} ${styles.innerContainerBasicInfo}`}>
            <BasicInfo
              hideNextButton={showMixrPicture || isPreviewUpdate}
              showNextSection={() => showSection('mixrPicture')}
              fromGroupId={fromGroupId || (isPreviewUpdate && selectedGroup && selectedGroup.group_id)}
              allGroups={groupsByOrgId ? groupsByOrgId.list : []}
              previewEditMode={isPreviewUpdate}
              handleSaveDraft={handleSaveDraft}
              groupLoading={groupsByOrgId?.loading}
            />
          </div>
        </div>

        {(showMixrPicture || isPreviewUpdate) && (
          <div
            ref={mixrPictureRef}
            className={`${styles.outerContainer} ${
              !showMixrVenue && !isPreviewUpdate && styles.outerContainerFullHeight
            }`}>
            <div className={styles.verticalLine}></div>
            <div className={`${styles.innerContainer} ${styles.innerContainerImgCropper}`}>
              <MixrPicture
                hideNextButton={showMixrVenue || isPreviewUpdate}
                showNextSection={() => showSection('mixrVenue')}
                editMode={false}
                previewEditMode={isPreviewUpdate}
              />
            </div>
          </div>
        )}

        {(showMixrVenue || isPreviewUpdate) && (
          <div
            ref={mixrVenueRef}
            className={`${styles.outerContainer} ${
              !showMixrTiming && !isPreviewUpdate && styles.outerContainerFullHeight
            }`}>
            <div className={styles.innerContainer}>
              <MixrVenue
                hideNextButton={showMixrTiming || isPreviewUpdate}
                showNextSection={() => showSection('mixrTiming')}
                previewEditMode={isPreviewUpdate}
              />
            </div>
            <div className={styles.verticalLine}></div>
          </div>
        )}

        {(showMixrTiming || isPreviewUpdate) && (
          <div
            ref={mixrTimingRef}
            className={`${styles.outerContainer} ${
              !showMixrInterests && !isPreviewUpdate && styles.outerContainerFullHeight
            }`}>
            <div className={`${styles.innerContainer} ${styles.innerContainerTiming}`}>
              <MixrTiming
                hideNextButton={showMixrInterests || isPreviewUpdate}
                showNextSection={() => showSection('mixrInterests')}
                previewEditMode={isPreviewUpdate}
                setHasFormErrors={setHasFormErrors}
              />
            </div>
            <div className={styles.verticalLine}></div>
          </div>
        )}

        {(showMixrInterests || isPreviewUpdate) && (
          <div
            ref={mixrInterestsRef}
            className={`${styles.outerContainer} ${
              !isAdvanceSettingsVisible && !isPreviewUpdate && styles.outerContainerFullHeight
            }`}>
            <div className={`${styles.innerContainer} ${styles.innerContainerInterests}`}>
              <MixrInterests
                hideNextButton={isAdvanceSettingsVisible || isPreviewUpdate}
                showNextSection={() => {
                  dispatch(mixrActions.showAdvanceSetting())
                }}
                previewEditMode={isPreviewUpdate}
                groupInterests={getGroupInterests()}
              />
            </div>
            <div className={styles.verticalLine}></div>
          </div>
        )}

        {(isAdvanceSettingsVisible || isPreviewUpdate) && (
          <div ref={lastContainerRef} className={`${styles.outerContainer} ${styles.lastContainer}`}>
            <AdvanceSettings
              previewEditMode={isPreviewUpdate}
              setHasFormErrors={setHasFormErrors}
              hasPriceSetting={true}
              hasInviteSetting={true}
              hasAttendenceSetting={true}
              innerContainerCss={styles.innerContainer}
              infoCss={styles.para}
            />

            <div class={`${styles.verticalLine} ${styles.lastVerticalLine}`} />

            <div className={styles.summaryAndSubmit}>
              <div className={styles.summaryContainer}>
                <p className={`${styles.para}`}>{t('event.create.summary1')}</p>
                <p className={`${styles.para}`}>{t('event.create.summary3')}</p>
              </div>

              {hasFormErrors ? (
                <div className={styles.formError}>{formErrorMessage || t('global.formError')}</div>
              ) : null}

              <div ref={buttonsRef} className={`${styles.buttonWrapper}`}>
                <Button
                  customStyle={`${styles.button} ${styles.previewButton}`}
                  style='secondary'
                  size='medium'
                  text={t('event.create.startFrom.previewMixr')}
                  handleClick={handleShowPreview}
                />
                <Button
                  customStyle={`${styles.button} ${styles.publishButton}`}
                  style='primary'
                  size='medium'
                  handleClick={handleCreateMixr}
                  text={
                    group?.can_suggest_mixr === 1 ? t('event.create.btnSuggestMixR') : t('event.create.publishMixr')
                  }
                />
              </div>
            </div>
          </div>
        )}

        {/* {showInviteMembers || isPreviewUpdate ? (
          <div ref={mixrInviteMembersRef} className={`${styles.outerContainer} ${styles.outerContainerFullHeight}`}>
            <div className={styles.innerContainer}>
              <InviteMembers handleShowPreview={handleShowPreview} setHasFormErrors={setHasFormErrors} />
              {hasFormErrors ? (
                <div className={styles.formError}>{formErrorMessage || t('global.formError')}</div>
              ) : null}
            </div>
            <div className={styles.verticalLine}></div>
          </div>
        ) : showPublishButton ? (
          <div className={styles.lastContainer}>
            <div className={styles.summaryContainer}>
              <p className={`${styles.para}`}>{t('event.create.summary1')}</p>
              <p className={`${styles.para}`}>{t('event.create.summary2')}</p>
            </div>

            <div ref={buttonsRef} className={`${styles.buttonWrapper}`}>
              <Button
                size='large'
                text={t('global.btnNext')}
                handleClick={handleShowPreview}
                // text={mixrActionType === 'plan' ? t('event.create.btnPublishMixR') : t('event.create.btnSuggestMixR')}
                // handleClick={handleCreateMixr}
              />
            </div>
          </div>
        ) : null} */}
      </form>
      {isSaveDraftModalOpen && (
        <SaveDraftModal
          isOpen={isSaveDraftModalOpen}
          closeModal={closeModal}
          handleLeave={handleLeave}
          handleSaveDraft={handleSaveDraft}
          error={saveDraft.error}
        />
      )}
      {showLoader && (
        <Popup
          nested
          contentStyle={{ background: colorVariables.whiteBG, border: '0', width: '100vw', height: '100vh' }}
          overlayStyle={{ background: 'rgba(46, 45, 45, 0.7)', backdropFilter: 'blur(7px)', zIndex: 1040 }}
          open={showLoader}
          onClose={closeLoaderModal}
          closeOnDocumentClick={false}
          closeOnEscape={false}>
          <Loader
            title={t('event.create.creatingMixrLoader', { mixrName: createdMixrName })}
            closeModal={closeLoaderModal}
          />
        </Popup>
      )}
      {showErrorPopup && (
        <Modal isOpen={showErrorPopup} handleClose={closeErrorPopup}>
          <ServerErrors
            errors={createUpdateErrors}
            title={t('group.createGroup.serverErrorTitle')}
            closeModal={closeErrorPopup}
          />
        </Modal>
      )}
    </PageContainer>
  )
}
